@if (navV2()) {
    <button class="no-label-list-item"
            mat-list-item
            (click)="toggle()">
        <div class="flex flex-col justify-center items-center">
            <div class="lendio-nav-item-state-layer">
                @if((count$ | async)) {
                    <mat-icon fontSet="material-icons-outlined"
                              [matBadgeSize]="(count$ | async) > 99 ? 'large' : 'medium'"
                              [matBadge]="(count$ | async) > 99 ? '99+' : (count$ | async)">
                        <span>notifications</span>
                    </mat-icon>
                } @else {
                    <mat-icon fontSet="material-icons-outlined">
                        <span>notifications</span>
                    </mat-icon>
                }
            </div>
        </div>
    </button>
} @else {
    <button mat-icon-button
            (click)="toggle()">
        @if ((count$ | async)) {
            <mat-icon color="accent"
                      [matBadgeSize]="(count$ | async) > 99 ? 'large' : 'medium'"
                      [matBadge]="(count$ | async) > 99 ? '99+' : (count$ | async)"
                      fontSet="material-icons-outlined">
                <span>notifications_active</span>
            </mat-icon>
        } @else {
            <mat-icon color="accent"
                      fontSet="material-icons-outlined">
                <span>notifications_inactive</span>
            </mat-icon>
        }
    </button>
}
